import React, { useLayoutEffect, useState } from 'react';
import Tab from './Tab';

const TAB_IDS = {
  PASSAGE_TAB: 'PASSAGE_TAB',
  QUESTION_TAB: 'QUESTION_TAB',
};

const ContentTabs = ({
  questionNr,
  passageContainerElements,
  questionContainerElements,
}) => {
  const [selectedTabId, setSelectedTabId] = useState(TAB_IDS.PASSAGE_TAB);

  const toggleElementsClass = (elements, className, condition) => {
    elements?.forEach((el) => {
      el?.classList?.toggle(className, condition);
    });
  };

  useLayoutEffect(() => {
    toggleElementsClass(passageContainerElements, 'bb-active-content', true);
    toggleElementsClass(questionContainerElements, 'bb-inactive-content', true);
  }, [passageContainerElements, questionContainerElements]);

  const onClick = (tabId) => {
    setSelectedTabId(tabId);

    const isPassageTabSelected = tabId === TAB_IDS.PASSAGE_TAB;
    const isQuestionTabSelected = tabId === TAB_IDS.QUESTION_TAB;
    toggleElementsClass(
      passageContainerElements,
      'bb-active-content',
      isPassageTabSelected,
    );
    toggleElementsClass(
      passageContainerElements,
      'bb-inactive-content',
      !isPassageTabSelected,
    );

    toggleElementsClass(
      questionContainerElements,
      'bb-active-content',
      isQuestionTabSelected,
    );
    toggleElementsClass(
      questionContainerElements,
      'bb-inactive-content',
      !isQuestionTabSelected,
    );
  };

  const tabClassName = 'h-[40px] flex-grow text-16 font-medium';
  const selectedTabClassName = 'text-white bg-bluebook-gray-900';

  return (
    <div className="pt-[16px] px-[10px] sticky top-0 z-10 bg-white">
      <div
        role="tablist"
        aria-labelledby="tablist-1"
        className="flex bg-bluebook-light-gray border-b-[2px]"
      >
        <Tab
          tabId={TAB_IDS.PASSAGE_TAB}
          className={tabClassName}
          isSelected={TAB_IDS.PASSAGE_TAB === selectedTabId}
          selectedClassName={selectedTabClassName}
          accessibility={{
            'aria-controls': `tabpanel-${TAB_IDS.PASSAGE_TAB}`,
          }}
          onClick={onClick}
        >
          Question {questionNr}
        </Tab>
        <Tab
          tabId={TAB_IDS.QUESTION_TAB}
          className={tabClassName}
          isSelected={TAB_IDS.QUESTION_TAB === selectedTabId}
          selectedClassName={selectedTabClassName}
          accessibility={{
            'aria-controls': `tabpanel-${TAB_IDS.QUESTION_TAB}`,
          }}
          onClick={onClick}
        >
          My Response
        </Tab>
      </div>
    </div>
  );
};

export default ContentTabs;
